export default {
    computed: {
        isProviderSelected() {
            if (this.fields.provider) {
                if (this.fields.provider.data) return true
            }

            return false
        },
    },
    methods: {
        onProviderChange(provider) {
            if (provider.data) {
                this.provider_data.address = provider.data.address
                this.provider_data.cp = provider.data.cp
                this.provider_data.location = provider.data.location
                this.provider_data.state = provider.data.state
                this.provider_data.country = provider.data.country
                this.provider_data.name = provider.data.name

                // Resetear los productos
                if (!this.loading) {
                    this.fields.concepts = []
                    this.createConcept()
                }
            } else {
                this.provider_data.address = ''
                this.provider_data.cp = ''
                this.provider_data.location = ''
                this.provider_data.state = ''
                this.provider_data.country = ''
                this.provider_data.name = ''
            }
        },
    }
}
